// src/components/pages/CheckoutSuccess.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const CheckoutSuccess = () => {
  return (
    <div className="py-16 px-4">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-2xl mx-auto text-center"
      >
        <h2 className="text-3xl font-['Orbitron'] text-white mb-6">
          Thank You for Your Pre-Order!
        </h2>
        <p className="text-gray-300 mb-8">
          Check your email for order confirmation and updates.
        </p>
        <Link 
          to="/"
          className="bg-gradient-to-r from-[#805AD5] to-[#FF4D00] text-white px-6 py-3 rounded-lg font-['Orbitron']"
        >
          Return Home
        </Link>
      </motion.div>
    </div>
  );
};

export default CheckoutSuccess;